import styled from 'styled-components'

const SlidePanel = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: white;
  border-top: ${props => (props.status === 'partial') ? '1px solid lightgrey' : '0px'};
  pointer-events: all;
  transform: ${props => (props.status === 'full') ? 'translateY(0%)' :
    (props.status === 'hide') ? 'translateY(100%)' :  'translateY(80%)'};
  transition: transform 0.5s ease-out;
`

export default SlidePanel;
